import React, { useEffect } from 'react';
import { observer } from 'owa-mobx-react';
import { lazyHandleSupportPaneEvents } from 'diagnostics-and-support';
import { useWindowEvent } from 'owa-react-hooks/lib/useWindowEvent';
import { Panel } from '@fluentui/react/lib/Panel';
import type { IPanelStyles } from '@fluentui/react/lib/Panel';
import { logCoreUsage } from 'owa-analytics';
import { useComputedValue } from 'owa-react-hooks/lib/useComputed';
import { closeButton } from 'owa-locstrings/lib/strings/closebutton.locstring.json';
import loc from 'owa-localize';

const iframeContainerStyle = { border: 'none' };

interface FeedbackDialogProps {
    iframeUrl: string;
    scenario: string;
    appName: string;
}

const FeedbackDialog = (props: FeedbackDialogProps) => {
    const styleProps: Partial<IPanelStyles> = useComputedValue(() => {
        return {
            main: {
                boxShadow:
                    'rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px',
            },
            content: {
                /* 50px from navigation panel, 24px from content y-padding*/
                height: 'calc(100vh - 74px)',
                paddingBottom: '20px',
                paddingTop: '4px',
            },
            scrollableContent: {
                height: '100%',
            },
        };
    }, []);

    const [isOpen, setIsOpen] = React.useState(true);
    const dismissPanel = React.useCallback(() => setIsOpen(false), []);

    useWindowEvent(
        'message',
        (messageEvent: any) => {
            lazyHandleSupportPaneEvents.importAndExecute(messageEvent);
        },
        'FeedbackDialog'
    );

    useEffect(() => {
        if (props.appName === 'Feedback') {
            logCoreUsage('FeedbackFeedbackDialogShown');
        } else if (props.appName === 'Eventify') {
            logCoreUsage('EventifyFeedbackDialogShown');
        } else if (props.appName === 'Places') {
            logCoreUsage('PlacesFeedbackDialogShown');
        } else if (props.appName === 'Bookabletime') {
            logCoreUsage('BookabletimeFeedbackDialogShown');
        } else if (props.appName === 'BookableTimeAutoFeedback') {
            logCoreUsage('BookableTimeAutoFeedbackFeedbackDialogShown');
        } else if (props.appName === 'Bookings') {
            logCoreUsage('BookingsFeedbackDialogShown');
        } else if (props.appName === 'BookingsMobileFeedback') {
            logCoreUsage('BookingsMobileFeedbackFeedbackDialogShown');
        } else if (props.appName === 'ArtificialWin32Toggle') {
            logCoreUsage('ArtificialWin32ToggleFeedbackDialogShown');
        }
    }, []);

    return (
        <Panel
            isOpen={isOpen}
            isBlocking={false}
            onDismiss={dismissPanel}
            styles={styleProps}
            closeButtonAriaLabel={loc(closeButton)}
        >
            <iframe
                src={props.iframeUrl}
                height={'100%'}
                width={'100%'}
                frameBorder="none"
                allow="display-capture"
                scrolling="auto"
                style={iframeContainerStyle}
            />
        </Panel>
    );
};

export default observer(FeedbackDialog, 'FeedbackDialog');
